module.exports = __webpack_public_path__ + "static/media/XLongCW.5dc60551.png";